export default "__VITE_ASSET__ff539deb__"